import React from "react";
import { connect } from "react-redux";
import { Actions as ADVISORACTIONS } from "../../store/actions/advisorActions";
import { CurrencyEuroIcon } from "@/icons/outline";
import { UserIcon } from "@/icons/solid";
import { Link } from "react-router-dom";
import Tooltip from "@/tooltip";
import { ClipboardIcon } from "@heroicons/react/20/solid";

const AdvisorRow = ({ advisor, switchAdvisor, plansList, showMarketInfo }) => {
	return (
		<tr>
			<td>
				<div
					className="btn btn-xs btn-default mr-3"
					type="button"
					onClick={() => navigator.clipboard.writeText(advisor?.id)}
					style={{ marginRight: "0.5rem" }}
				>
					<Tooltip content="Copy Advisor ID">
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</Tooltip>
				</div>

				<Link
					to={`/advisor`}
					type="button"
					onClick={(e) => {
						switchAdvisor(advisor?.id);
					}}
				>
					{advisor?.name}
				</Link>
			</td>
			<td style={{ textAlign: "center" }}>{plansList?.find((plan) => plan.id == advisor?.plan)?.name}</td>
			<td style={{ textAlign: "center" }}>{advisor?.status}</td>
			<td style={{ textAlign: "center" }}>{advisor?.jurisdiction}</td>
			<td style={{ textAlign: "center", display: showMarketInfo ? "" : "none" }}>
				{advisor?.marketingInfo?.noOfEmployees}
			</td>
			<td style={{ textAlign: "center", display: showMarketInfo ? "" : "none" }}>
				{advisor?.marketingInfo?.noOfPayrolls}
			</td>
			<td style={{ textAlign: "center", display: showMarketInfo ? "" : "none" }}>
				{advisor?.marketingInfo?.payrollSoftware}
			</td>
			<td style={{ display: showMarketInfo ? "none" : "" }} />
			<td className="text-right">
				<div className="btn-group">
					<Tooltip content="Switch To Advisor And View Team">
						<Link
							to={`/advisor/team`}
							className="btn btn-xs btn-default mr-3"
							type="button"
							onClick={(e) => {
								switchAdvisor(advisor?.id);
							}}
						>
							<UserIcon className="w-6 h-6 media-middle" />
						</Link>
					</Tooltip>
				</div>
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {
	return {
		plansList: state?.payment?.bundles,
	};
};

const mapDispatchToProps = (dispatch) => ({
	switchAdvisor: (companyId) => dispatch(ADVISORACTIONS.switchAdvisor(companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorRow);
